import React from "react";
import { Link } from "react-router-dom";
import { Button, Form, Input } from "antd";
import { SVGicon } from "../../../styleGuide/SVGicon/SVGicon";
import './SignInContent.css'

const validateMessages = {
    required: "'${label}' is Required!",
    types: {
        email: "'${label}' is not a valid email!"
    },
};

export const SignInContent = () => {

    return (
        <>
            <div>
                <div className="sign-in-modal-wrap">
                    <h6 className="fw-600 text-color-alpha">Sign In to you now</h6>
                    <p className="fw-400  text-color-bravo">The marketplace for healthcare jobs.</p>

                    <div>
                        <Form
                            layout="vertical"
                            autoComplete="off"
                            className="mtp-form"
                            initialValues={{ remember: true, }}
                            validateMessages={validateMessages}>

                            <Form.Item name="email" label="Email" rules={[{ type: "email", required: true, }]}>
                                <Input placeholder="Ex. xyz@mail.com" className="mtp-form-control" />
                            </Form.Item>

                            <Form.Item name="Password" label="Password" rules={[{ required: true, }]} >
                                <Input.Password className="mtp-form-control" placeholder="Password " />
                            </Form.Item>

                            <Form.Item className="mb-0">
                                <Button className="CustomButton" type="prime" htmlType="submit"> Sign In</Button>
                            </Form.Item>

                        </Form>

                        <div className="forgot-pass-link-wrap text-center">
                            <Link className="forgot-pass-link fw-500 " to="">Forgot Password? </Link>
                        </div>

                        <div className="not-acc-sign-up-wrap text-center">
                            <span className="fw-400 ">Don’t have an account? <Link to="/signup" className="sign-up-link fw-500" >Sign Up </Link></span>
                        </div>
                        <div className="sign-in-social-wrap flex-center">
                            <a href="https://www.facebook.com/MetropolisAI" target="_blank" rel="noreferrer" className="navigation-link footer-social-link flex-center flex-auto-0 contain-image">{SVGicon.mtpIconSocialFacebook}</a>
                            <a href="https://www.twitter.com/MetropolisTech" target="_blank" rel="noreferrer" className="navigation-link footer-social-link flex-center flex-auto-0 contain-image">{SVGicon.mtpIconSocialTwitter}</a>
                            <a href="https://www.instagram.com/metropolis.tech" target="_blank" rel="noreferrer" className="navigation-link footer-social-link flex-center flex-auto-0 contain-image">{SVGicon.mtpIconSocialInstagram}</a>
                            <a href="https://www.linkedin.com/company/51719281" target="_blank" rel="noreferrer" className="navigation-link footer-social-link flex-center flex-auto-0 contain-image">{SVGicon.mtpIconSocialLinkedIn}</a>
                            <a href="mailto:support@metropolis.tech" rel="noreferrer" className="navigation-link footer-social-link flex-center flex-auto-0 contain-image">{SVGicon.mtpIconContactEmail}</a>
                            <a href="tel:4047770098" rel="noreferrer" className="navigation-link footer-social-link flex-center flex-auto-0 contain-image">{SVGicon.mtpIconContactPhone}</a>
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}